export default {
    setError(state, errorData) {
        state.dangerAlert = true
        state.dangerMessage = errorData
    },

    setSuccess(state, msgData) {
        state.successAlert = true
        state.successMessage = msgData
    },

    SET_REGISTER_RESULT(state, data) {
        state.register_result = data;
    },
    SET_CurrentUser(state, data) {
        state.currentUser = data;
    },
}